import React from 'react'

/** 用于 `<Trans>` 中插值 */
export function Slot({ content }) {
    return <>{content}</>
}

export default Slot
